export default {
  categories: state => state.categories,
  categoryInfos: state => state.categoryInfos,
  totalPages: state => state.totalPages
}
